import { EntityType } from '@frontend/common';
import { GroupSelectV2 } from '@frontend/group/select';
import { updateField } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useProductGroupConstraintDataInput from './product-group-constraint-data-input.controller';

const ID = 'product-group-constraint-data-input';
export interface ProductGroupConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const ProductGroupConstraintDataInput = (props: ProductGroupConstraintDataInputProps) => {
    const viewProps = useProductGroupConstraintDataInput(props);

    return (
        <div
            id={ID}
            className='flex w-full flex-row'>
            <GroupSelectV2
                type={EntityType.PRODUCT_GROUP}
                required
                value={viewProps.formValues?.product_group_id ?? undefined}
                onChange={(v) => {
                    props.dispatch(updateField({ formId: props.formId, key: 'data', value: v ? { product_group_id: v } : undefined }));
                }}
            />
        </div>
    );
};

export default ProductGroupConstraintDataInput;
